var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-0 pa-sm-12",class:this.$vuetify.breakpoint.smAndUp ? 'border-radius-xl' : '',attrs:{"height":"100%","color":"transparent","tile":this.$vuetify.breakpoint.smAndUp ? false : true}},[_c('v-img',{attrs:{"src":_vm.imageUrl,"min-height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }